import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateEncodeSpecificationMpeg4Form } from "../forms/create/CreateEncodeSpecificationMpeg4Form";

export type AddEncodeSpecificationMpeg4ButtonProps = ButtonProps;

export const AddEncodeSpecificationMpeg4Button: FunctionComponent<AddEncodeSpecificationMpeg4ButtonProps> = (
    props: AddEncodeSpecificationMpeg4ButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add MPEG-4" icon="Add" disabled={disabled} />
            <Aside
                isOpen={isAsideOpen}
                type="form"
                headerText={"Add Encode Specification MPEG-4"}
                onDismiss={closeAside}
            >
                <CreateEncodeSpecificationMpeg4Form onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
